<ng-container *transloco="let convert;">
  <app-modal tabindex="-1" [modalId]="'new-posting-modal'" [labelledby]="'new-posting-modal'"
    class="new-posting-modal"
    (keydown.escape)="close()">
    <!--      Begin Modal Layout Containers-->
    @if (isLoading) {
      <ng-content *ngTemplateOutlet="loading"></ng-content>
    }
    @if (initialPostingStageReady) {
      <ng-content *ngTemplateOutlet="vinDecodeResult" id="newPostingModal"></ng-content>
    }
    @if (inspectionStageReady) {
      <ng-content *ngTemplateOutlet="inspectionReportResultTemplate"></ng-content>
    }
    @if (!isLoading && thirdPartyPostingRequest) {
      <ng-content *ngTemplateOutlet="thirdPartyPostingTemplate"></ng-content>
    }
    @if (!isLoading) {
      <ng-content *ngTemplateOutlet="buttons"></ng-content>
    }
    <!--      End Modal Layout Containers-->
    <!--      Begin Templates -->
    <ng-template #loading>
      <div class="spinner-container">
        <app-spinner></app-spinner>
      </div>
    </ng-template>
    <!--    Begin VIN  Decode Modal Template-->
    <ng-template #vinDecodeResult>
      <ng-container>
        <div class="modal-close-container text-end">
          <button
            id="new-posting-modal-close"
            class="modal__close"
            aria-label="Close modal"
            (click)="close()"
            data-track-elem="icon"
            data-track-name="close"
            data-track-trigger="close"
            >
            <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
          </button>
        </div>
        <header class="modal__header pb-3 d-block">
          @if (decodedDetails) {
            <h4 class="modal__title mb-0 fw-bold" tabindex="-1"
              [innerHTML]="convert('sellModule.posting.newPosting.newPostingModal.textVinDecodeSuccessHeader',
                {vin: vin, decodedDetails: decodedDetails.vehicleDescription})">
            </h4>
          }
          @if (errorHeaderKey) {
            <div class="error-header">
              <div class="error-icon me-2">
                <img
                  class="image-exclamation"
                  src="assets/icons/exclamation.svg"
                  alt="error"
                  />
              </div>
              <h4 class="modal__title mb-0 fw-bold" tabindex="-1"
                [innerHTML]="convert('sellModule.posting.newPosting.newPostingModal.' + errorHeaderKey, {vin: vin})">
              </h4>
            </div>
          }
        </header>
        <div class="modal__content">
          <ng-container>
            <div>
              @if (decodedDetails) {
                <p
                  [innerHTML]="convert('sellModule.posting.newPosting.newPostingModal.textVinDecodeSuccessMessage')">
                </p>
              }
              @if (errorMessageKey && !decodedDetails) {
                <p class="error-content"
                  [innerHTML]="convert('sellModule.posting.newPosting.newPostingModal.' + errorMessageKey, {vin: vin})">
                </p>
              }
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-template>
    <!--    End VIN Decode Modal Template-->
    <!--      Begin Inspection Report Result -->
    <ng-template #inspectionReportResultTemplate>
      <ng-container>
        <div class="modal-close-container text-end">
          <button
            id="new-posting-inspection-modal-close"
            class="modal__close"
            aria-label="Close modal"
            (click)="close()"
            data-track-elem="icon"
            data-track-name="close"
            data-track-trigger="close"
            >
            <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
          </button>
        </div>
        <header class="modal__header pb-3 d-block">
          @if (existingInspectionReport) {
            <h4 class="modal__title mb-0 fw-bold" tabindex="-1"
              [innerHTML]="convert('sellModule.posting.newPosting.newPostingModal.textInspectionReportFoundHeader', { inspectionDate: localizeDate(existingInspectionReport?.inspectionData?.statusDate)})">
            </h4>
          }
          @if (!existingInspectionReport && !errorHeaderKey) {
            <h4 class="modal__title mb-0 fw-bold" tabindex="-1"
              [innerHTML]="convert('sellModule.posting.newPosting.newPostingModal.textInspectionReportNotFoundHeader')">
            </h4>
          }
          @if (errorHeaderKey) {
            <div class="error-header">
              <div class="error-icon me-2">
                <img
                  class="image-exclamation"
                  src="assets/icons/exclamation.svg"
                  alt="error"
                  />
              </div>
              <h4 class="modal__title mb-0 fw-bold" tabindex="-1"
                [innerHTML]="convert('sellModule.posting.newPosting.newPostingModal.' + errorHeaderKey)">
              </h4>
            </div>
          }
        </header>
        @if (inspectionFetched) {
          <div class="modal__content text-start">
            @if (!errorResponse) {
              <form class="form-group">
                @if (existingInspectionReport) {
                  <a
                    class="view-inspection-link"
                    [href]="existingInspectionReport.reportUrl"
                  target="_blank">{{convert('sellModule.posting.newPosting.newPostingModal.textViewInspectionLink')}}</a>
                }
                <p>{{convert('sellModule.posting.newPosting.newPostingModal.textInspectionReportSelect')}}</p>
                @for (inspectionAction of availableInspectionActions; track inspectionAction) {
                  <div class="custom-control custom-radio"
                    >
                    <input type="radio"
                      [id]="inspectionAction.name"
                      name="inspection-actions"
                      [title]="inspectionAction.value"
                      class="custom-control-input radio"
                      [value]="inspectionAction.value"
                      [checked]="inspectionAction.isChecked"
                      (change)="toggleInspectionSelection(inspectionAction.name)"
                      [attr.aria-labelledby]="inspectionAction.ariaLabel"
                      [attr.aria-checked]="inspectionAction.isChecked"
                      />
                    <label class="custom-control-label ellipsis-overflow"
                      [title]="inspectionAction.value"
                      [for]="inspectionAction.name">
                      {{ inspectionAction.value }}
                    </label>
                  </div>
                }
              </form>
            }
            @if (errorResponse) {
              <div>
                @if (errorMessageKey) {
                  <p class="error-content text-start"
                    [innerHTML]="convert('sellModule.posting.newPosting.newPostingModal.' + errorMessageKey)">
                  </p>
                }
              </div>
            }
          </div>
        }
      </ng-container>
    </ng-template>
    <!--    Begin Third Party Posting Modal Template-->
    <ng-template #thirdPartyPostingTemplate>
      <ng-container>
        <div class="modal-close-container text-end">
          <button
            class="modal__close"
            aria-label="Close modal"
            (click)="close()"
            data-track-elem="icon"
            data-track-name="close"
            data-track-trigger="close"
            >
            <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
          </button>
        </div>
        <header class="modal__header text-center pb-3 d-block">
          @if (errorHeaderKey) {
            <div class="error-header mt-2">
              <div class="error-icon me-2">
                <img
                  class="image-exclamation"
                  src="assets/icons/exclamation.svg"
                  alt="error"
                  />
              </div>
              <h4 class="modal__title mb-0 text-start fw-bold" tabindex="-1"
                [innerHTML]="convert('sellModule.posting.newPosting.newPostingModal.' + errorHeaderKey, {vin: vin})">
              </h4>
            </div>
          }
        </header>
        <div class="modal__content">
          <ng-container>
            <div>
              @if (errorMessageKey) {
                <p class="error-content"
                  [innerHTML]="convert('sellModule.posting.newPosting.newPostingModal.' + errorMessageKey)">
                </p>
              }
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-template>

    <!--    Begin Button templates -->
    <ng-template #buttons>
      @if (!errorResponse && initialPostingStageReady) {
        <div class="decode-success-buttons d-flex flex-column flex-lg-row lg-justify-content-start mb-2">
          <button class="btn btn-primary btn-continue" (click)="continueWithDecodedVin()"
            [attr.aria-label]="convert('common.btnContinue')">
            {{convert('common.btnContinue')}}
          </button>
          <button class="btn btn-link outline-focus" (click)="close()"
            [attr.aria-label]="convert('common.btnCancel')">
            {{convert('common.btnCancel')}}
          </button>
        </div>
      }
      @if (inspectionStageReady) {
        <div class="inspection-buttons d-flex flex-column flex-lg-row lg-justify-content-start mb-2">
          @if (errorResponse) {
            <button class="btn btn-primary btn-continue" (click)="continueWithDecodedVin()"
              [attr.aria-label]="convert('common.btnRetry')">
              {{convert('common.btnRetry')}}
            </button>
          }
          <button class="btn btn-primary btn-continue" (click)="continueWithChromeCall()"
            [attr.aria-label]="convert('common.btnContinue')">
            {{convert('common.btnContinue')}}
          </button>
          <button class="btn btn-link outline-focus" (click)="close()"
            [attr.aria-label]="convert('common.btnCancel')">
            {{convert('common.btnCancel')}}
          </button>
        </div>
      }
      @if (errorResponse && !inspectionStageReady) {
        <div class="error-buttons d-flex flex-column flex-lg-row justify-content-center mb-2">
          <button class="btn btn-primary" (click)="close()" [attr.aria-label]="convert('common.btnClose')">
            {{convert('common.btnClose')}}
          </button>
        </div>
      }
    </ng-template>
    <!--      End Templates -->
  </app-modal>
</ng-container>
